import React, { useState } from "react";
import {
  Button,
  ButtonBase,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  Divider,
  TextField,
  Paper,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import MainSectionContainer from "../../../subComponents/MainSectionContainer";
import { addPupils, deletePupils } from "../../../firebase/functions";
import { useDispatch, useSelector } from "react-redux";
import { classesThunk } from "../../../redux/adminSlice";
import { pupilsThunk } from "../../../redux/staffSlice";

const Pupils = () => {
  const [open, setOpen] = useState(false);
  const [pupil, setPupil] = useState("");

  const dispatch = useDispatch();

  const {
    staff: {
      data: { className, id: teacherId },
    },
    pupils: { data: pupilsData },
  } = useSelector((state) => state.staff);

  const handleModalChange = () => {
    setOpen((prev) => !prev);
  };
  const createEntry = () => {
    addPupils({ name: pupil.toLowerCase(), className, teacherId }).then(() => {
      console.log("New Pupil Entry Created");
      dispatch(pupilsThunk());
      handleModalChange();
    });
  };
  return (
    <Grid
      container
      direction="column"
      height="100%"
      paddingTop="12px"
      bgcolor="primary.opaque">
      <Grid
        container
        item
        justifyContent="space-around"
        width="100%"
        spacing={3}>
        <Grid item>
          <Typography component="b">
            Tot. No of Pupils:{" "}
            <span style={{ fontWeight: "bold" }}>{pupilsData.length}</span>
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleModalChange}>
            Add a Pupil
          </Button>
        </Grid>
      </Grid>
      <Grid item xs>
        <MainSectionContainer>
          <Modal
            open={open}
            onClose={handleModalChange}
            createEntry={createEntry}
            pupil={pupil}
            setPupil={setPupil}
          />

          <ClassPupils pupilsData={pupilsData} />
        </MainSectionContainer>
      </Grid>
    </Grid>
  );
};

export default Pupils;

const Modal = ({ onClose, open, pupil, setPupil, createEntry }) => {
  const handleChange = (e) => {
    setPupil(e.target.value);
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <Grid
        container
        spacing={2}
        minWidth="50vw"
        maxWidth={400}
        padding="0px 16px 12px">
        <Grid item xs={12}>
          <DialogTitle>Add a Pupil</DialogTitle>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="standard-basic"
            name="pupil"
            label="Standard"
            variant="standard"
            value={pupil}
            fullWidth
            sx={{ textTransform: "capitalize" }}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            // variant="contained"
            onClick={createEntry}
            style={{
              width: "60%",
              maxWidth: 250,
            }}>
            Create Entry
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

const ClassPupils = ({ pupilsData }) => {
  const dispatch = useDispatch();
  return (
    <Paper>
      {pupilsData.map((pupilData, i) => (
        <Grid container>
          <Grid item xs>
            <ButtonBase
              style={{ width: "100%", display: "block" }}
              component="div">
              <Typography
                variant="body1"
                padding="24px 16px"
                fontWeight="bold"
                style={{ textTransform: "capitalize" }}>
                {pupilData.name}
              </Typography>
            </ButtonBase>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                const studYear = pupilData.pupilID.split("/")[2];
                deletePupils({
                  id: pupilData.id,
                  className: pupilData.className,
                  studYear,
                }).then(() => {
                  dispatch(pupilsThunk());
                });
                console.log("delete");
              }}
              startIcon={<DeleteIcon />}>
              Del
            </Button>
          </Grid>
          <Divider style={{ width: "100%" }} />
        </Grid>
      ))}
    </Paper>
  );
};
